import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=4e4f698c&scoped=true&"
import script from "./forgetPass.vue?vue&type=script&lang=js&"
export * from "./forgetPass.vue?vue&type=script&lang=js&"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=4e4f698c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f698c",
  null
  
)

export default component.exports